import { ESP_ACCOUNT_PAYLOAD_FIELDS, AuthType } from '../../../../types';

const {
  ESP,
  API_KEY,
  NAME,
  CLIENT_ID,
  CLIENT_SECRET,
  TOKEN_ENDPOINT,
  CUSTOM_HEADERS,
  API_ENDPOINT,
  AUTH_TYPE,
} = ESP_ACCOUNT_PAYLOAD_FIELDS;

export const createCustomEmailAccountPayload = (values: Record<string, any>) => {
  const { name, esp, apiEndpoint, clientId, clientSecret, tokenEndpoint, customHeaders } = values;

  const customHeadersObj = customHeaders.reduce(
    (acc: Record<string, string>, { key, value }: { key: string; value: string }) => {
      acc[key] = value;
      return acc;
    },
    {} as Record<string, string>,
  );

  return {
    [API_KEY]: '',
    [ESP]: esp,
    [NAME]: name,
    customMTAConfig: {
      [NAME]: name,
      /**
       * Note that apiEndpoint maps to customMtaConfig.apiEndpoint for CustomMTA Esp Accounts,
       * rather than espAccount.apiEndpoint.
       */
      [API_ENDPOINT]: apiEndpoint,
      [AUTH_TYPE]: AuthType.OAUTH2,
      authParams: {
        [CLIENT_ID]: clientId,
        [CLIENT_SECRET]: clientSecret,
        [TOKEN_ENDPOINT]: tokenEndpoint,
      },
      [CUSTOM_HEADERS]: customHeadersObj,
    },
  };
};

export const createEditCustomEmailAccountPayload = (values: Record<string, any>) => {
  const { id, isDefault, editApiKey, editClientSecret } = values;
  return {
    ...createCustomEmailAccountPayload(values),
    id,
    editApiKey,
    editClientSecret,
    isDefault,
  };
};
